import { useRoute } from '@react-navigation/native';
import { navigationRef } from '@helpers';
import { MachinesScreen, NowSubScreen } from '@v2/pages/machines/common/enums';
import { MACHINES_MAIN_SCREEN } from '@v2/pages/machines/navigation/config';
import { LevelSubScreen } from '@v2/pages/common/enums';

export const useDocumentsNavigation = () => {
  const route = navigationRef?.current?.getCurrentRoute();

  const handleNowScreenNavigation = ({ nowSubScreen, params = {} }: { nowSubScreen: NowSubScreen; params?: Record<string, unknown> }) => {
    navigationRef.current?.navigate(MACHINES_MAIN_SCREEN + MachinesScreen.LIVE, {
      screen: nowSubScreen,
      params: {
        screen: nowSubScreen + LevelSubScreen.DOCUMENTS,
        params: {
          ...route.params,
          ...params,
        },
      },
    });
  };

  return { handleNowScreenNavigation };
};
